import * as React from "react";
import Icon from "../../types/Icon.interface";

const IconPlus: React.FC<Icon> = (props: Icon) => {
  const { color = "#002D5A", className, style } = props;

  return (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      className={className}
      style={style}
    >
      <g fill={color} fillRule="evenodd">
        <path d="M9.5 0h2v21h-2z" />
        <path d="M21 9.5v2H0v-2z" />
      </g>
    </svg>
  );
};

export default IconPlus;
